import { ProductReviewDetail } from 'api/products/_requests';
import axios from 'axios';
import { handleRequest } from 'helpers/api';

const DASHBAORD_URL = `${process.env.REACT_APP_API_URL}/dashboard`;

const DashboardApi = axios.create({
  baseURL: DASHBAORD_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface BrandsData {
  _id?: string;
  name: string;
  image: string;
  category: string;
  industry: string;
  createdAt: string;
}

export interface BrandSummary {
  today: number;
  week: number;
  month: number;
  year: number;
  all: number;
}

export interface BrandResponse {
  totalProducts: number;
  soldProducts: number;
  unsoldProducts: number;
}

export interface DashboardData {
  products: number | 0;
  weekorders: number | 0;
  totalOrders: number | 0;
}

export interface OrderData {
  _id?: string;
  status: string;
  vendorId: string;
  totalAmount: number;
  finalAmount: number;
  userId: string;
  createdAt: string;
}

export interface OrderStatsData {
  _id?: string;
  totalSpent: number;
  totalProducts: number;
  count: number;
}

export interface ProductsData {
  _id?: string;
  name: string;
  createdAt: string;
  brand: string;
  category: string;
}

export interface CustomersData {
  _id?: string;
  fullName: string;
  totalOrders: number;
  totalSpent: number;
  createdAt: string;
}

export type RangeType = 'today' | 'week' | 'month' | 'year' | 'custom';

export type OrderParams = {
  id?: string;
  range?: RangeType | null;
  startDate?: string;
  endDate?: string;
};
export type OrderDataRegion = {
  _id?: string;
  country?: string;
  totalOrders?: number;
  totalUsers?: number;
  totalProducts?: number;
};

export const getDashboard = async (id: string | undefined) => {
  if (!id) throw new Error('Vendor ID is required');
  return handleRequest(DashboardApi.get<DashboardData>(`/all-data/${id}`));
};

export const getOrderDataByRegion = async (id?: string) => {
  return handleRequest(
    DashboardApi.get<OrderDataRegion[]>(`/order-data-by-region/${id}`)
  );
};

export const getOrderData = async (params: OrderParams) => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce(
      (acc, [key, val]) => {
        if (val !== undefined && val !== null) acc[key] = val;
        return acc;
      },
      {} as Record<string, string>
    )
  ).toString();

  return handleRequest(
    DashboardApi.get<OrderData[]>(`/all-order-data?${queryString}`)
  );
};

export const getProductData = async (params: {
  range?: string;
  id?: string;
}) => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce(
      (acc, [key, val]) => {
        if (val !== undefined && val !== null) acc[key] = val;
        return acc;
      },
      {} as Record<string, string>
    )
  ).toString();
  return handleRequest(
    DashboardApi.get<ProductsData[]>(`/all-product-data?${queryString}`)
  );
};

export const getSoldUnsoldProductsByVendor = async (id?: string) => {
  return handleRequest(
    DashboardApi.get<BrandResponse>(`/sold-unsold-products-by-vendor/${id}`)
  );
};

export const getOrderStatsData = async (params: OrderParams) => {
  const queryString = new URLSearchParams(
    Object.entries(params).reduce(
      (acc, [key, val]) => {
        if (val !== undefined && val !== null) acc[key] = val;
        return acc;
      },
      {} as Record<string, string>
    )
  ).toString();

  return handleRequest(
    DashboardApi.get<OrderStatsData>(`/product-by-order?${queryString}`)
  );
};
